import { createMessageName } from '@formkit/validation';
import { sentence, date, order, list } from '../formatters.mjs';

// packages/i18n/src/locales/he.ts
var add = "הוסף";
var remove = "מחק";
var removeAll = "מחק הכל";
var incomplete = "שים לב, לא כל השדות מלאים כראוי.";
var submit = "שלח";
var noFiles = "לא נבחר קובץ..";
var moveUp = "הזז למעלה";
var moveDown = "הזז למטה";
var isLoading = "טוען...";
var loadMore = "טען יותר";
var next = "הבא";
var prev = "הקודם";
var addAllValues = "הוסף את כל הערכים";
var addSelectedValues = "הוספת ערכים נבחרים";
var removeAllValues = "הסר את כל הערכים";
var removeSelectedValues = "הסר ערכים נבחרים";
var chooseDate = "בחר תאריך";
var changeDate = "שינוי תאריך";
var close = "סגור";
var open = "פתוח";
var accepted = function({
  name
}) {
  return `אנא אשר את ${name}.`;
};
var date_after = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} חייב להיות אחרי ${date(args[0])}.`;
  }
  return `${sentence(name)} חייב להיות בעתיד.`;
};
var alpha = function({
  name
}) {
  return `${sentence(name)} חייב להכיל אותיות אלפבת.`;
};
var alphanumeric = function({
  name
}) {
  return `${sentence(name)} יכול להכיל רק מספרים ואותיות.`;
};
var alpha_spaces = function({
  name
}) {
  return `${sentence(name)} יכול להכיל רק אותיות ורווחים.`;
};
var contains_alpha = function({
  name
}) {
  return `${sentence(name)} חייב להכיל תווים אלפביתיים.`;
};
var contains_alphanumeric = function({
  name
}) {
  return `${sentence(name)} חייב להכיל אותיות או מספרים.`;
};
var contains_alpha_spaces = function({
  name
}) {
  return `${sentence(name)} חייב להכיל אותיות או רווחים.`;
};
var contains_symbol = function({
  name
}) {
  return `${sentence(name)} חייב להכיל סמל.`;
};
var contains_uppercase = function({
  name
}) {
  return `${sentence(name)} חייב להכיל אותיות רישיות.`;
};
var contains_lowercase = function({
  name
}) {
  return `${sentence(name)} חייב להכיל אותיות קטנות.`;
};
var contains_numeric = function({
  name
}) {
  return `${sentence(name)} חייב להכיל מספרים.`;
};
var symbol = function({
  name
}) {
  return `${sentence(name)} חייב להיות סמל.`;
};
var uppercase = function({
  name
}) {
  return `${sentence(name)} יכול להכיל אותיות רישיות בלבד.`;
};
var lowercase = function({
  name
}) {
  return `${sentence(name)} יכול להכיל רק אותיות קטנות.`;
};
var date_before = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} חייב להיות לפני ${date(args[0])}.`;
  }
  return `${sentence(name)} חייב להיות בעבר`;
};
var between = function({
  name,
  args
}) {
  if (isNaN(args[0]) || isNaN(args[1])) {
    return `שדה זה לא הוגדר כראוי ולא יכול להישלח.`;
  }
  const [a, b] = order(args[0], args[1]);
  return `${sentence(name)} חייב להיות בין ${a} ו- ${b}.`;
};
var confirm = function({
  name
}) {
  return `${sentence(name)} לא מתאים.`;
};
var date_format = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} הוא לא תאריך תקין, אנא השתמש בפורמט ${args[0]}`;
  }
  return "שדה זה לא הוגדר כראוי ולא יכול להישלח.";
};
var date_between = function({
  name,
  args
}) {
  return `${sentence(name)} חייב להיות בין ${date(args[0])} ו- ${date(args[1])}`;
};
var email = "אנא הקלד אימייל תקין.";
var ends_with = function({
  name,
  args
}) {
  return `${sentence(name)} לא מסתיים ב- ${list(args)}.`;
};
var is = function({
  name
}) {
  return `${sentence(name)} הוא לא ערך מורשה.`;
};
var length = function({
  name,
  args: [first = 0, second = Infinity]
}) {
  const min2 = Number(first) <= Number(second) ? first : second;
  const max2 = Number(second) >= Number(first) ? second : first;
  if (min2 == 1 && max2 === Infinity) {
    return `${sentence(name)} חייב להיות לפחות תו אחד.`;
  }
  if (min2 == 0 && max2) {
    return `${sentence(name)} חייב להיות פחות או שווה ל- ${max2} תווים.`;
  }
  if (min2 === max2) {
    return `${sentence(name)} צריך להיות ${max2} תווים ארוכים.`;
  }
  if (min2 && max2 === Infinity) {
    return `${sentence(name)} חייב להיות גדול או שווה ל- ${min2} תווים.`;
  }
  return `${sentence(name)} חייב להיות בין ${min2} ו- ${max2} תווים.`;
};
var matches = function({
  name
}) {
  return `${sentence(name)} הוא לא ערך תקין.`;
};
var max = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `${name} לא יכול להיות עם יותר מ- ${args[0]}.`;
  }
  return `${sentence(name)} חייב להיות פחות או שווה ל- ${args[0]}.`;
};
var mime = function({
  name,
  args
}) {
  if (!args[0]) {
    return "פורמט הקובץ לא מורשה.";
  }
  return `${sentence(name)} חייב להיות מסוג: ${args[0]}`;
};
var min = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `${name} לא יכול להיות עם פחות מ- ${args[0]}.`;
  }
  return `${sentence(name)} חייב להיות לפחות ${args[0]}.`;
};
var not = function({
  name,
  node: {
    value
  }
}) {
  return `“${value}” לא מתאים ל- ${name}.`;
};
var number = function({
  name
}) {
  return `${sentence(name)} חייב להיות מספר.`;
};
var require_one = function({
  name,
  node,
  args: inputNames
}) {
  const labels = inputNames.map((name2) => {
    const dependentNode = node.at(name2);
    if (dependentNode) {
      return createMessageName(dependentNode);
    }
    return false;
  }).filter((name2) => !!name2);
  labels.unshift(name);
  return `${labels.join(" או ")} נדרש.`;
};
var required = function({
  name
}) {
  return `${sentence(name)} הינו חובה.`;
};
var starts_with = function({
  name,
  args
}) {
  return `${sentence(name)} לא מתחיל ב- ${list(args)}.`;
};
var url = function() {
  return `הזן כתובת URL חוקית.`;
};
var invalidDate = "התאריך שנבחר אינו חוקי.";
var ui = {
  add,
  remove,
  removeAll,
  incomplete,
  submit,
  noFiles,
  moveUp,
  moveDown,
  isLoading,
  loadMore,
  next,
  prev,
  addAllValues,
  addSelectedValues,
  removeAllValues,
  removeSelectedValues,
  chooseDate,
  changeDate,
  close,
  open
};
var validation = {
  accepted,
  date_after,
  alpha,
  alphanumeric,
  alpha_spaces,
  contains_alpha,
  contains_alphanumeric,
  contains_alpha_spaces,
  contains_symbol,
  contains_uppercase,
  contains_lowercase,
  contains_numeric,
  symbol,
  uppercase,
  lowercase,
  date_before,
  between,
  confirm,
  date_format,
  date_between,
  email,
  ends_with,
  is,
  length,
  matches,
  max,
  mime,
  min,
  not,
  number,
  require_one,
  required,
  starts_with,
  url,
  invalidDate
};
var he_default = {
  ui,
  validation
};

export { accepted, add, addAllValues, addSelectedValues, alpha, alpha_spaces, alphanumeric, between, changeDate, chooseDate, close, confirm, contains_alpha, contains_alpha_spaces, contains_alphanumeric, contains_lowercase, contains_numeric, contains_symbol, contains_uppercase, date_after, date_before, date_between, date_format, he_default as default, email, ends_with, incomplete, invalidDate, is, isLoading, length, loadMore, lowercase, matches, max, mime, min, moveDown, moveUp, next, noFiles, not, number, open, prev, remove, removeAll, removeAllValues, removeSelectedValues, require_one, required, starts_with, submit, symbol, uppercase, url };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=he.mjs.map